
import { Vue } from "vue-class-component";
export default class ConnectedLayout extends Vue {}
